module.exports = __webpack_public_path__ + "static/media/Fagunsmall.9fe36278.jpg";